// Porównanie „naturalne" — fragmenty liczbowe po wartości, nie znak po znaku,
// więc np. FV/9/2026 wypada przed FV/10/2026.
export function naturalCompare(a: string, b: string): number {
  return a.localeCompare(b, "pl", { numeric: true });
}
